// ============================================
// SHARED HOOK: useResetBuilder
// Used by 7 parent components
// ============================================

import {useEffect} from 'react';
import {OVRecommendActionEnum} from '../../../schema-types/globalTypes';
import {useAutoForm} from '../../../components/AutoForm/useAutoForm';
import {UPDATES} from '../../../shared/UPDATES';
// import {useAccountContext} from '../../contexts/AccountContext';

export const useResetBuilder = (planType: OVRecommendActionEnum) => {
  const {setFieldValue} = useAutoForm();
  // const {builderDetails} = useAccountContext();
  useEffect(() => {
    if (planType !== OVRecommendActionEnum.CONTRIBUTE) {
      setFieldValue(UPDATES._120, 'contribute', null);
    }
    if (planType !== OVRecommendActionEnum.WITHDRAW) {
      setFieldValue(UPDATES._121, 'withdraw', null);
    }
    if (planType !== OVRecommendActionEnum.TRANSFER) {
      setFieldValue(UPDATES._122, 'transfer', null);
    }
    if (planType !== OVRecommendActionEnum.SET_UP_NEW) {
      setFieldValue(UPDATES._123, 'setUpNew', null);
    }
    if (planType !== OVRecommendActionEnum.AD_HOC_FEE) {
      setFieldValue(UPDATES._124, 'adHocFee', null);
    }
  }, []);
  // useEffect(() => {}, [builderDetails]);
};
